import { Injectable, inject } from '@angular/core';
import { PartnerService } from './partner.service';
import { IPartnerService } from '../../interfaces/partner-services';
import { CommunityConfigService } from '../util/community-config.service';
import { Partner } from '../../interfaces/partner';

@Injectable({
  providedIn: 'root',
})
export class BrandonService extends PartnerService implements IPartnerService {
  private brandonUrl = inject(CommunityConfigService).getExternalApi(Partner.BRANDON);

  override getServiceUrl(): string {
    return this.brandonUrl;
  }
}
